import axios from 'axios';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setTrainCategories(state, data) {
      state.list = data;
    },
  },
  actions: {
    fetchFromServer({ commit }) {
      axios.get('/api/train-categories')
        .then(response => commit('setTrainCategories', response.data))
        .catch(error => console.log(error));
    },
  },
};
